module.exports = __webpack_public_path__ + "media/images/ticbali-9885e3e187366b4c949cfa7c89fa5a63.png";